import React, { isValidElement } from 'react';
import { Modal, TouchableOpacity, Dimensions, View, Easing, Text, TouchableWithoutFeedback, Animated } from 'react-native';
import { Shadow } from '@qnpm/q-shadow';
import { Icon, Colors } from '@qnpm/q-theme';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
import { getContentStyle } from './util';
import PopupLayerStyle from './styles';
const popupLayerColors = Colors.scenes.popupLayerColors;
const screen = Dimensions.get('window');
// eslint-disable-next-line react/no-redundant-should-component-update
export class PopupLayer extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = () => {
            let onClose = this.props.onClose;
            onClose && onClose();
        };
        this.onMaskClose = () => {
            if (this.props.maskClosable) {
                this.closeModal();
            }
        };
        this.getPosition = (visible) => {
            if (visible) {
                return 0;
            }
            return screen.height - 44;
        };
        this.getOpacity = (visible) => {
            return visible ? 1 : 0;
        };
        this.animateMask = (visible) => {
            this.stopMaskAnim();
            this.state.opacity.setValue(this.getOpacity(!visible));
            this.animMask = Animated.timing(this.state.opacity, {
                toValue: this.getOpacity(visible),
                duration: this.props.animationDuration,
                useNativeDriver: true
            });
            this.animMask.start(() => {
                this.animMask = null;
            });
        };
        this.stopMaskAnim = () => {
            if (this.animMask) {
                this.animMask.stop();
                this.animMask = null;
            }
        };
        this.stopDialogAnim = () => {
            if (this.animDialog) {
                this.animDialog.stop();
                this.animDialog = null;
            }
        };
        this.animateDialog = (visible) => {
            this.stopDialogAnim();
            this.animateMask(visible);
            let { animationType, animationDuration } = this.props;
            animationDuration = animationDuration;
            if (animationType !== 'none' && visible) {
                if (animationType === 'slide') {
                    this.state.position.setValue(this.getPosition(!visible));
                    this.animDialog = Animated.timing(this.state.position, {
                        toValue: this.getPosition(visible),
                        duration: animationDuration,
                        easing: (visible ? Easing.elastic(0.8) : undefined),
                        useNativeDriver: true
                    });
                }
                this.animDialog.start(() => {
                    this.animDialog = null;
                    if (!visible) {
                        this.setState({
                            modalVisible: false
                        });
                    }
                    if (this.props.onShow) {
                        this.props.onShow(visible);
                    }
                });
            }
            else {
                if (!visible) {
                    this.setState({
                        modalVisible: false
                    });
                }
            }
        };
        this.getTitle = (title, titleAlign, shadow, needScale) => {
            let { accessibilityPreName = '' } = this.props;
            let styles = this.style.getStyle();
            if (isValidElement(title)) {
                return title;
            }
            let titleContent = (<View style={styles.header}>
                <View style={styles.headerContent}>
                    <Text {...qAccessibilityLabel(`${accessibilityPreName}qdPopupLayer#title`)} style={[
                styles.headerText,
                { textAlign: titleAlign ? 'left' : 'center' }
            ]}>
                        {title}
                    </Text>
                </View>
                <TouchableOpacity {...qAccessibilityLabel(`${accessibilityPreName}qdPopupLayer#close`)} style={styles.icon} hitSlop={{ left: 8, top: 8, right: 8, bottom: 8 }} onPress={this.closeModal}>
                    <Icon name="close" size={18} needScale={needScale} color={popupLayerColors.iconColor}/>
                </TouchableOpacity>
            </View>);
            if (shadow) {
                return (<Shadow shadow="shadow3" shadowPosition="top">
                    {titleContent}
                </Shadow>);
            }
            return titleContent;
        };
        // 初始状态
        const { visible, needScale } = props;
        this.style = new PopupLayerStyle(needScale);
        this.state = {
            position: new Animated.Value(this.getPosition(visible)),
            opacity: new Animated.Value(this.getOpacity(visible)),
            modalVisible: visible
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.shouldComponentUpdate(nextProps, null)) {
            this.setState({
                modalVisible: true
            });
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.visible || this.props.visible !== nextProps.visible) {
            return true;
        }
        if (nextState) {
            if (nextState.modalVisible !== this.state.modalVisible) {
                return true;
            }
        }
        return false;
    }
    componentDidMount() {
        if (this.props.animateAppear && this.props.animationType !== 'none') {
            // @ts-ignore
            this.componentDidUpdate({});
        }
    }
    componentDidUpdate(prevProps) {
        const { props } = this;
        if (prevProps.visible !== props.visible) {
            this.animateDialog(props.visible);
            // 设置左滑收拾（展示时禁止，否则设置为可用）
            this.toggleSwipeControl(!props.visible);
        }
    }
    componentWillUnmount() {
        this.stopDialogAnim();
    }
    /**
     * 禁止左滑返回
     * @param enable
     */
    toggleSwipeControl(enable) {
        const { swipeBackControl } = this.props;
        // eslint-disable-next-line no-undef
        swipeBackControl &&
            global.Ext &&
            global.Ext.setSwipeBackEnabled(enable);
    }
    render() {
        let { maskStyle, animationType, wrapStyle, title, style, perHeight, shadow, titleAlign, needScale, hasHeader } = this.props;
        let styles = this.style.getStyle();
        let { modalVisible } = this.state;
        if (!modalVisible) {
            return null;
        }
        const animationStyleMap = {
            none: {},
            slide: { transform: [{ translateY: this.state.position }] }
        };
        return (<Modal animationType="none" transparent={true} visible={modalVisible} 
        // @ts-ignore TODO 暂时禁止检查，不防止打包
        statusBarTranslucent={true} onRequestClose={this.closeModal}>
                <View style={[styles.wrap, wrapStyle]}>
                    <TouchableWithoutFeedback onPress={this.onMaskClose} style={[
            styles.absolute,
            { opacity: this.state.opacity }
        ]}>
                        <Animated.View style={[
            styles.absolute,
            { opacity: this.state.opacity }
        ]}>
                            <View style={[
            styles.absolute,
            styles.mask,
            maskStyle
        ]}/>
                        </Animated.View>
                    </TouchableWithoutFeedback>
                    <Animated.View style={[
            styles.content,
            getContentStyle(perHeight),
            animationStyleMap[animationType],
            style
        ]}>
                        {hasHeader
            ? this.getTitle(title, titleAlign, shadow, needScale)
            : null}
                        {this.props.children}
                    </Animated.View>
                </View>
            </Modal>);
    }
}
PopupLayer.defaultProps = {
    animationType: 'slide',
    animateAppear: false,
    animationDuration: 300,
    visible: false,
    maskClosable: true,
    perHeight: 100,
    onClose() { },
    shadow: false,
    onShow() { },
    needScale: false,
    hasHeader: true,
    accessibilityPreName: '',
    swipeBackControl: false
};
